import gql from 'graphql-tag';

export default gql`
  query PrintOrderInvoice($input: PrintOrderInvoiceInput!) {
    printOrderInvoice(input: $input) {
      pdf
      success
      errorMessage
    }
  }
`;
